<template>
  <div class="b">
    <Nav :current="current"></Nav>
    <div class="titleBox">
      <!--       
 -->
      <el-button
      v-if="treeBtn.add"
        type="primary"
        size="small"
        class="edit l yellow bgBtn"
        @click="showModelHandle('top', null)"
        >添加顶级部门</el-button
      >
      <div class="seatch">
      <div>
        <span>名称:</span> <input type="text" v-model="name"/>
      </div>
       <div>
        <span>部门级别:</span> <input type="text" v-model="level" />
      </div>
     <div style="margin:0;">
        <span class="el-icon-search" @click="getSearchList"></span>
      </div>
  </div>
    </div>
    <!-- 页面加载和点击懒加载展开时 tapTable =1   点击搜索时判断有参数还是没有参数   有参数就显示树形菜单   没有就显示懒加载树形菜单-->

    <div class="el-table-box">
      <vxe-table
      v-if="tapTable==1"
        border
        resizable
        ref="xTree"
        row-id="id"
        
        :height="tableHeight"
        highlight-hover-row
        highlight-current-row
        :loading="loading"
        :tree-config="{
          lazy: islazy,
           hasChild: 'hasChild',
          children: 'children',
          loadMethod: loadChildrenMethod,
        }"
        :data="tableData.data"
        @scroll="scrollEvent"
      >
        <vxe-table-column
          field='name'  
          title="名称"
          width="700"
          tree-node
        >        
        </vxe-table-column>
         <vxe-table-column
          field="sonNum"
          title="子级部门数量"
          width="240"
        >
        </vxe-table-column>
        <vxe-table-column
          field="description"
          title="职能描述"
          width="400"
        ></vxe-table-column>
        <vxe-table-column width="300"  field="level" title="部门级别"></vxe-table-column>
        <vxe-table-column
          width="300"
          field="createdAt"
          title="创建时间"
        ></vxe-table-column>
        <vxe-table-column width="200" field="createName" title="创建者"></vxe-table-column>
        <vxe-table-column  fixed="right" min-width="200" field="" title="操作">
          <template #default="{ row }">
            <!--  v-if="treeBtn.edit" -->
            <div
              class="link-btn border-right display-inline-block"
             v-if="treeBtn.edit"
              @click="showModelHandle('edit', row)"
            >
              编辑
            </div>
            <!--  -->
            <div
           v-if="treeBtn.delete"
              class="link-btn border-right display-inline-block"
              @click="showModleDeleteHandle(row)"
            >
              删除
            </div>
            <!--   -->
            <div
              class="link-btn display-inline-block"
             v-if="treeBtn.addsub"
              @click="showModelHandle('child', row)"
            >
              新建子部门
            </div>
          </template>
        </vxe-table-column>
    </vxe-table>
   </div> 
      <div class="el-table-box">
      <vxe-table
        v-if="tapTable==2"
            border
        resizable
        ref="xTrees"
        row-id="id"

        :height="tableHeight"
        highlight-hover-row
        highlight-current-row
        :loading="loading"
        :tree-config="{
          expandAll:true,//展开所有子级
        
           hasChild: 'hasChild',
          children: 'children',
          loadMethod: loadChildrenMethod1,
        }"
        :data="tableData.data"
        @scroll="scrollEvent"
          >
        <vxe-table-column
          field='name'  
          title="名称"
          width="400"
          tree-node
        >        
        </vxe-table-column>
         <vxe-table-column
          field="sonNum"
          title="子级部门数量"
          width="140"
        >
        </vxe-table-column>
        <vxe-table-column
          field="description"
          title="职能描述"
        ></vxe-table-column>
        <vxe-table-column field="level" title="部门级别"></vxe-table-column>
        <vxe-table-column
          width="200"
          field="createdAt"
          title="创建时间"
        ></vxe-table-column>
        <vxe-table-column field="createName" title="创建者"></vxe-table-column>
        <vxe-table-column class="sticky sticky-right" fixed="right" width="200" field="" title="操作">
          <template #default="{ row }">
            <div
              class="link-btn border-right l"
              v-if="treeBtn.edit"
              @click="showModelHandle('edit', row)"
            >
              编辑
            </div>
            <div
              class="link-btn border-right l"
            
             v-if="treeBtn.delete"
              @click="showModleDeleteHandle(row)"
            >
              删除
            </div>
            <!--
               v-if="treeBtn.edit"  编辑  
              v-if="treeBtn.addsub" 新建子级
                    v-if="treeBtn.delete"  删除
 -->
            <div
              class="link-btn l"
               v-if="treeBtn.addsub"
              @click="showModelHandle('child', row)"
            >
              新建子部门
            </div>
          </template>
        </vxe-table-column>
    </vxe-table> 

    </div>
    <!-- 弹框 -->
    <vxe-modal  v-model="isShowDelete" title="温馨提示" width="300"  height="180">
      <vxe-form title-align="right" title-width="100">
        <vxe-form-item align="center" span="24">您确定要删除吗？</vxe-form-item>
        <vxe-form-item align="center" span="24">
          <template #default>
            <vxe-button @click="isShowDelete = false">取消</vxe-button>
            <vxe-button
              style="background: #55c4b8; color: #fff"
              @click="deleHandle"
              >确认</vxe-button
            >
          </template>
        </vxe-form-item>
      </vxe-form>
    </vxe-modal>

    <vxe-modal v-model="showModel" width="600" :title="modelFormType=='top' ? '添加部门': modelFormType=='edit' ? '编辑部门': '新建子部门'">
      <template #default>
        <vxe-form
          ref="formRef"
          :data="addFormData"
          title-align="right"
          title-width="100"
          :rules="formRules"
          @submit="createForm"
        >
          <vxe-form-item
            v-if="modelFormType != 'top'"
            disabled
            title="上级部门"
            field="parentDepartment.name"
            :item-render="{}"
          >
            <template #default>
              <vxe-input
                disabled
                v-model="parentDepartment.name"
                placeholder=""
                clearable
              >
              </vxe-input>
            </template>
          </vxe-form-item>

          <vxe-form-item
            title="部门名称"
            field="name"
            :item-render="{}"
          >
            <template #default="params">
              <vxe-input
                v-model="params.data.name"
                placeholder="请输入部门名称"
                clearable
                @change="changeEvent(params)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item
            title="职能描述"
            field="description"
            :item-render="{}"
          >
            <template #default="params">
              <vxe-input
                v-model="params.data.description"
                placeholder="请输入职能描述"
                clearable
                max-length="200"
                @change="changeEvent(params)"
              >
              </vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item align="center" span="24">
            <template #default>
              <vxe-button type="submit" status="primary">保存</vxe-button>
              <vxe-button @click="showModel = false">取消</vxe-button>
            </template>
          </vxe-form-item>
        </vxe-form>
      </template>
    </vxe-modal>

  </div>
</template>
<script>
import http from "@/config/httpConfig";
import apiData from "@/config/api";
import Nav from "@/components/Nav.vue";

function T() {
  return {
    id: "",
    name: "", //部门名字
    description: "", //部门描述
    parentId: "", //部门上级
    parentName:''
  };
}
export default {
  name: "HelloWorld",
  components: {
    Nav,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      tapTable:'1',
      current: '我的公司',
      pageSize: 100000,
      islazy:true,//是否懒加载  
      treeNode:true,
      loading: false,
      selectRow: null, //当前选中的行
      deleId: "",
      name:'',
      level:'',
      parentId: "",
      tableData: {
        data: [],
      },
      formRules: {
        name: [
          { required: true, message: "请输入部门名称"},
          { min: 1, max: 60, message: '最多可输入60个字符' }
        ],
        description: [
          { min: 0, max: 200, message: '最多可输入200个字符' }
        ],
        
      },
      showModel: false,
      modelFormType: "top",
      parentDepartment: T(),
      addFormData: T(),
      isShowDelete: false, //删除部门
      tableHeight: 400,
      deleteRow: [],
      rowObj: "",
      treeBtn: {
        add: false,
        edit: false,
        delete: false,
        addsub: false
      }
    };
  },
  mounted() {
    this.getList();
    this.getTableHeight();
    let listMenuAll = JSON.parse(localStorage.getItem('listMenu'))
    if(listMenuAll && listMenuAll.length){
      for (let index = 0; index < listMenuAll.length; index++) {
        const listMenu = listMenuAll[index];
        if (listMenu.children) {
          this.navList = listMenu.children.map(itemOne => {
            if (itemOne.level === "020102") {//公司设置
              itemOne["current"] = true
              if (itemOne.children) {
                itemOne.children.forEach((item, index) => {
                  if (item.opCode === "dep.add") {
                    this.treeBtn.add = true
                  }
                  if(item.opCode === "dep.edit"){
                    this.treeBtn.edit = true
                  }
                  if(item.opCode === "dep.delete"){
                    this.treeBtn.delete = true
                  }
                  if(item.opCode === "dep.addsub"){
                    this.treeBtn.addsub = true
                  }
                })
              }
            }
            return itemOne
          })
        }
      }
    }
    
  },
  methods: {
    // 2026/03/15 lucina 部门名称/职能描述 最多可输入60个字符/200个字符
   changeEvent (params) {
      const $form = this.$refs.formRef
      if ($form) {
        $form.updateStatus(params)
      }
    },
    scrollEvent ({ direction, isLeft, isRight, isTop, isBottom }) {
      console.log(`方向 ${direction}`,direction, isLeft, isRight, isTop, isBottom);
      if (isLeft) {
          console.log('触碰到左侧');
      }
      if (isRight) {
          console.log('触碰到右侧');
      }
      if (isTop) {
          console.log('触碰到顶部');
      }
      if (isBottom) {
          console.log('触碰到底部');
      }
    },
    createForm: function () {
      var _this = this;
      var type = _this.modelFormType;
      var url = "";
      var msg = "";
      var data = {
        parentId: _this.parentId, //上级id
        name: _this.addFormData.name, //部门名字
        description: _this.addFormData.description, //部门描述
      };
      if (type === "top") {
        //顶级
        msg = "添加成功";
        data.parentId = "";
        this.addDataParent();
      } else if (type === "edit") {
        //编辑 20251114 HB364/HB375 编辑子级打不开/描述不生效
        data.id = _this.addFormData.id;
        data.name = _this.addFormData.name;
        data.description = _this.addFormData.description;
        _this.selectRow.name = _this.addFormData.name
        _this.selectRow.description = _this.addFormData.description
        http.put(
          apiData.updatePartment,
          true,
          {
            id: data.id,
            name: data.name,
            parentId: data.parentId,
            description: data.description
          },
          (res) => {
            if (res.data.code == 200) {
              _this.$message.success("编辑成功");
              _this.showModel = false;
            } else {
              _this.$message.error("编辑失败");
            }
          }
        );
      } else if (type === "child") {
        //新建子部门
        http.post(apiData.addChildPartment, true, data, (res) => {
          if (res.data.code == 200) {
            
            // window.location.reload()
            // 为某个父级节点添加子节点
            console.log('添加成功',res?.data?.data)
            _this.appendChildNode(_this.parentId, res?.data?.data ?? {});
            _this.$message.success("添加成功");
            _this.showModel = false;
          } else {
            _this.$message.error("添加失败");
          }
        });
      }
      console.log(data);
    },
    // 添加部门
    addDataParent() {
      let _this = this;
      let params = {
        name: _this.addFormData.name,
        description: _this.addFormData.description,
      };
      http.post(apiData.addDepartment, true, params, (res) => {
        if (res.data.code == 200 || _this.name != null) {
          _this.$message.success("添加成功");
          _this.showModel = false;
          //  _this.getList();
          // 添加顶级
           res.data.data.hasChild = false
          let _data = res.data.data
          _this.tableData.data.unshift(_data)
          
           
        } else {
          _this.$message.success("添加失败");
        }
      });
    },
    showModelHandle: function (type, row) {
      //展示弹框
      var _this = this;
      _this.parentId = ""; //清空上级id
      _this.parentDepartment = T();
      _this.addFormData = T();
      _this.modelFormType = type;
      console.log(type, row,'添加部门');
      if (type === "top") {
        //顶级
        _this.showModel = true;
      } else if (type === "edit") {
        //编辑
        _this.showModel = true;
        _this.addFormData = JSON.parse(JSON.stringify(row));
        
        _this.selectRow = row;
        // console.log(_this.addFormData.parentId ,'编辑')

        // 原for循环遍历写法
        // for (let i = 0; i < _this.tableData.data.length; i++) {
        //   // console.log(_this.tableData.data[i].id)
        //   if(_this.addFormData.parentId == _this.tableData.data[i].id){
        //     // alert(1)
        //    _this.parentDepartment.name = _this.tableData.data[i].name
        //    break;
        // }else{
        //   _this.parentDepartment.name = '无'
        // }
        //
        // }

        // 发送请求获取后台/organizationstructure/department/show接口，获取到字段后赋值

        var parproms = {
          name : row.name,
          id   : row.id
        }
        http.get(apiData.departmentName, true, parproms, (res) => {
          if (res.data.data.parentName) {
            _this.parentDepartment.name = res.data.data.parentName
            console.log(res)

          } else {
            _this.parentDepartment.name = "无"
          }
        });

        // console.log(_this.selectRow )

      } else if (type === "child") {
        //新建子部门
        _this.parentDepartment = JSON.parse(JSON.stringify(row));
        _this.showModel = true;
        _this.parentId = row.id;
         _this.selectRow = row;
        
      }

      this.$refs?.formRef?.clearValidate()
    },
    // 删除
    deleHandle: function () {
      // this.
      let _this = this;
      // console.log("点击", _this.rowObj.id);
      let params = {
        id: _this.rowObj.id,
      };
      http.delete(apiData.deletePartment, true, params, (res) => {
        if (res.data.code == 200) {
          _this.$message.success("删除成功");
          _this.parentId = ''
          _this.isShowDelete = false;
         
          
          // 执行删除操作
          this.deleteNode(_this.tableData.data, _this.rowObj.id);
        } else {
          _this.$message.error(res.msg);
        }
      });
    },
    // 从树形结构中删除节点
    deleteNode(nodes, nodeId){
      for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].id === nodeId) {
          nodes.splice(i, 1);
          return true;
        }
        if (nodes[i].children && nodes[i].children.length > 0) {
          const deleted = this.deleteNode(nodes[i].children, nodeId);
          if (deleted) {
            // 检查父节点是否还有子节点
            if (nodes[i].children.length === 0) {
              nodes[i].hasChild = false;
            }
            return true;
          }
        }
      }
      return false;
    },
    // 删除的弹框
    showModleDeleteHandle: function (row) {
      var _this = this;
      // console.log(row);
      _this.rowObj = row;
      _this.isShowDelete = true;
    },
    getSearchList(){
       var _this = this;
       if(_this.name != '' || _this.level != ''){ //只输入一个值  怎么走进去 
  //  alert(123);
          _this.tapTable = 2
       var params ={
          pageNum: _this.currentPage,
        pageSize: _this.pageSize,
        name:_this.name,
        level:_this.level
       }

        http.get(apiData.companyList, true, params, function (res) {
       if(res.data.code == 200){
          if (res.data.data) {
     
          _this.tableData.data = res.data.data.list;
          _this.totalRow = res.data.data.totalRow;
          // _this.$refs.xTrees.setAllTreeExpansion(true)
          //  _this.$refs.xTrees.setAllTreeExpand(true);
           _this.$nextTick(() => _this.$refs.xTrees.setAllTreeExpand(true));
        } else {
         
        }
       }else{
         _this.$message.error(res.data.msg)
       }
      });
       }else{
         _this.tapTable = 1
          _this.getList()
       }
    },
    getList: function () {
      var _this = this;
      var params = {
        pageNum: _this.currentPage,
        pageSize: _this.pageSize,
        parentId: _this.parentId,
        name:_this.name,
        level:_this.level
      };

      http.get(apiData.companyList, true, params, function (res) {
       if(res.data.code == 200){
         
          if (res.data.data) {
          _this.tableData.data = res.data.data.list;
          _this.totalRow = res.data.data.totalRow;
           console.log(_this.tableData.data,123)
           for (let i = 0; i < _this.tableData.data.length; i++) {
                   
                    if(_this.tableData.data[i].sonNum>=1){
                      _this.tableData.data[i].hasChild = true 
                    }else{
                      _this.tableData.data[i].hasChild = false 

                    }
                    
                  }

        } else {
          
        }
       }else{
         _this.$message.error(res.data.msg)
       }
      });
    },
    loadChildrenMethod ({ row }) {
      var _this = this
      var id = row.id
      var params = {
        parentId: id,
      }
      // 如果该节点已经手动加载过子节点，直接返回现有的children
      if (row.treeLoaded && row.children && row.children.length > 0) {
        return Promise.resolve(row.children)
      }
      
      return new Promise((resolve, reject) => {
          // console.log(params)
          _this.parentId = id;
           
          http.get(apiData.companyList, true, params, function (res) {
             var tableData = res.data.data.list
            if (res.data.data.list.length) {

              for (let i = 0; i < tableData.length; i++) {
                 if(tableData[i].sonNum == 0){
                    tableData[i].hasChild = false 
                    // console.log(tableData[i].hasChild,'展开后的数据')
                     
                    }
              }
              // 合并服务器数据和本地已有的children（如果有的话）
              var mergedData = tableData
              if (row.children && row.children.length > 0) {
                // 过滤掉重复的节点（根据id判断）
                var existingIds = tableData.map(item => item.id)
                var localOnly = row.children.filter(item => !existingIds.includes(item.id))
                mergedData = [...localOnly, ...tableData]
              }
              resolve(mergedData)
              console.log('数组长度',mergedData)  
            } else {
              _this.$message.warning('当前节点没有下级！')
              
            }
             _this.parentId = ''
          });
      })
      .then(res => {
          console.log(res)
          return res
      })
      .catch(err => {
          console.log(err)
      })
    },
    loadChildrenMethod1 ({ row }) {
      var _this = this
      var id = row.id
      var params = {
        parentId:id,
         name:_this.name,
        level:_this.level
      }
        _this.parentId = id 
        
      // 如果该节点已经手动加载过子节点，直接返回现有的children
      if (row.treeLoaded && row.children && row.children.length > 0) {
        return Promise.resolve(row.children)
      }
        
      return new Promise((resolve, reject) => {
          // console.log(params)
          _this.parentId = id;
           
          http.get(apiData.companyList, true, params, function (res) {
             var tableData = res.data.data.list
            if (res.data.data.list.length) {

              for (let i = 0; i < tableData.length; i++) {
                 if(tableData[i].sonNum == 0){
                    tableData[i].hasChild = false 
                    console.log(tableData[i].hasChild)
                    }
              }
              // 合并服务器数据和本地已有的children（如果有的话）
              var mergedData = tableData
              if (row.children && row.children.length > 0) {
                // 过滤掉重复的节点（根据id判断）
                var existingIds = tableData.map(item => item.id)
                var localOnly = row.children.filter(item => !existingIds.includes(item.id))
                mergedData = [...localOnly, ...tableData]
              }
              resolve(mergedData)
              console.log('数组长度',mergedData)  
            } else {
              
            //  _this.tableData.data.push({hasChild : false })
              
              _this.$message.warning('当前节点没有下级！')
              
            }
             _this.parentId = ''
          });
      })
      .then(res => {
          console.log(res)
          return res
      })
      .catch(err => {
          console.log(err)
      })
    },
    getTableHeight() {
      let _this = this
      _this.$utils.getTableHeight(_this, 70)//搜索的高度32+40(margin)
    },
    // 为指定节点追加子节点
    appendChildNode(parentId, childNode) {
      let _this = this
      // 找到父节点
      const findParentNode = (nodes) => {
        for (let node of nodes) {
          if (node.id === parentId) {
            return node
          }
          if (node.children && node.children.length > 0) {
            const found = findParentNode(node.children)
            if (found) {
              return found
            }
          }
        }
        return null
      }
      
      // 查找父节点
      const parentNode = findParentNode(this.tableData.data)
      console.log('是否有父节点',parentNode)
      if (parentNode) {
        // 确保children数组存在
        if (!parentNode.children) {
          this.$set(parentNode, 'children', [])
        }
        
        // 准备子节点数据，设置必要的属性
        const preparedChildNode = {
          ...childNode,
          hasChild: false,  // 新添加的节点默认没有子节点
          sonNum: 0,        // 子节点数量默认为0
          level: (parentNode.level || 0) + 1,  // 层级为父节点层级+1
        }
        
        console.log('添加的子节点',parentNode,parentNode.children,preparedChildNode)
        parentNode.children.unshift(preparedChildNode)
        
        // 更新父节点的属性
        parentNode.sonNum = (parentNode.sonNum || 0) + 1
        parentNode.hasChild = true
        // 标记父节点已经加载过子节点，防止懒加载重复加载
        parentNode.treeLoaded = true
        
        // 根据tapTable的值选择正确的table组件
        const tableRef = _this.tapTable == 1 ? _this.$refs.xTree : _this.$refs.xTrees
        
        // 确保vxe-table的treeLoaded属性存在
        try {
          console.log('fullAllDataRowMap-更新缓存--1',tableRef,_this,this.$refs.xTree)
          if (tableRef && typeof tableRef === 'object' && tableRef !== null) {
            console.log('fullAllDataRowMap-更新缓存--2',tableRef)

            // 更新vxe-table内部缓存，确保新添加的节点能被正确识别
            if (typeof tableRef.updateCache === 'function') {
              console.log('fullAllDataRowMap-更新缓存')
              tableRef.updateCache(true)
            }
            // 刷新表格数据
            if (typeof tableRef.updateData === 'function') {
              tableRef.updateData()
            } else if (typeof tableRef.refresh === 'function') {
              tableRef.refresh()
            }
            // 确保treeLoaded属性存在
            if (!tableRef.treeLoaded) {
              tableRef.treeLoaded = true;
            }
            console.log('数据哈哈--', tableRef)
          }
        } catch (error) {
          console.error('设置treeLoaded属性时出错:', error);
        }
        
        return true
      }
      
      return false
    },
  },
};
</script>
<style lang="less">
.b {
  margin: 0 10px;
}
.vxe-form--item-content {
  .vxe-input {
    width: 440px;
  }
}
.b {
  margin: 0 10px;
}
.vxe-form--item-content {
  .vxe-input {
    width: 440px;
  }
}

.b {
  margin: 0 10px;
}

.vxe-form--item-content {
  .vxe-input {
    width: 440px;
  }
}

.vxe-table--render-default .vxe-body--column:not(.col--ellipsis),
.vxe-table--render-default .vxe-footer--column:not(.col--ellipsis),
.vxe-table--render-default .vxe-header--column:not(.col--ellipsis) {
  padding: 8px 0 !important;
}
.titleBox {
  display: inline-block;
  width: 100%;
  margin: 10px auto;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #333;

  .txt {
    display: inline-block;
    margin-right: 10px;
  }
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
.seatch {
  width: 100%;
  height: 30px;
  margin-left: 10px;
  div {
    float: left;
    margin-right: 10px;
    margin-left: 10px;
  }
  input {
    width: 300px;
    height: 30px;
    padding-left: 5px;
    margin-left: 5px;
  }
.el-icon-search {
    font-size: 20px;
    margin-top: 6px;
  }
}
.vxe-table--render-default .vxe-tree--node-btn {
    display: block;
    color: #939599;
}

</style>